"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bool = void 0;
const DEFAULTS = {
    trueValue: 'Yes',
    falseValue: 'No',
    nullValue: ''
};
const TRUTHY = [true, 'true', 'True', 'TRUE', 'yes', 'Yes', 'YES'];
const FALSY = [false, 'false', 'False', 'FALSE', 'no', 'No', 'NO'];
function bool(opts) {
    const vals = { ...DEFAULTS, ...opts };
    const result = function boolFormatter(row, cell, value, columnDef, data) {
        if (opts.trueIfHasValue) {
            value = value != null;
        }
        if (opts.falseIfHasNoValue) {
            value = value == null;
        }
        return TRUTHY.indexOf(value) > -1
            ? vals.trueValue
            : FALSY.indexOf(value) > -1
                ? vals.falseValue
                : vals.nullValue;
    };
    result.filterFormattedData = true;
    return result;
}
exports.bool = bool;
//# sourceMappingURL=bool.js.map